import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
import FormAction from 'app/modules/Hr/reports/ShiftReport/EmploymentReportShiftAction'

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class EmploymentReportShiftActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/modules/Hr/reports/ShiftReport/EmploymentReportShift")
	}

	render() {
		return (
			<Activity 
				name="EmploymentReportShift"
				RenderedComponent={this.RenderedComponent}
				context="EmploymentReportShift"
				action="EmploymentReportShift"
				formActions={FormAction}			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(EmploymentReportShiftActivity)
